import { render, staticRenderFns } from "./metadataList.vue?vue&type=template&id=22c4a6fc"
import script from "./metadataList.vue?vue&type=script&lang=js"
export * from "./metadataList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports